import api from "../index";

export const GetPammTokenApi = (params) => api.get("UserMaster/get-pamm-token", { params });
